export default __webpack_public_path__ + "static/media/AccessDenied.0f814ddd.png";